import { createContext, useContext } from 'react'

import { User } from '@shared-types/domain'

export const OptionalUserContext = createContext<User | undefined>(undefined)
export const useOptionalUser = () => useContext(OptionalUserContext)
